module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Add-music-c2a094795b3398976f8004c837ad0590.svg";